import { httpPost, httpDownload, httpGet } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../../constants/external-constants';
import Moment from 'moment';
import { getLocalTimeZone, convertToUtcDate } from '../../../../utils/helpers.utils';
import { actions } from 'react-redux-form';
import {
    getInventoryCircuit,
    getInventoryCircuitEquipment,
    getInventoryCircuitEquipmentModel,
    getEquipmentDetailsList,
    setInventoryCircuitError,
    setInventoryCircuitColSearchStr,
    sortInventoryCircuitItems,
    setInventoryCircuitPageSize,
    setInventoryCircuitFilter,
    applyInventoryCircuitFilter,
    getInventoryCircuitDetail,
    getInventoryUserDetail,
    getInventoryUserCircuitAllocation,
    getUserLinkedCircuit,
    getInventoryCircuitLocationAddress,
    getInventoryCircuitLocationP2P,
    getInventoryAllAccountDetails,
    getInventoryAllCircuitStatuses,
    getInventoryAllCircuitSimTypes,
    getInventoryCircuitComments,
    getInventoryAllCircuitRankings,
    getInventoryAllAccountTypes,
    getInventoryAllCircuitTypes,
    getInventoryAllSubCircuitTypes,
    getInventoryAllLocations,
    getInventoryAllEmployees,
    getInventoryCircuitAccessTypes,
    getInventoryCircuitAccessBandWidthTypes,
    getInventoryCircuitEOOITypes,
    getInventoryCircuitYesOrNoOption,
    getInventoryCircuitServiceClass,
    getInventoryCircuitPortSpeed,
    getInventoryCircuitCarrierQoSProfile,
    getInventoryCircuitVPNName,
    getInventoryCircuitVoiceCarSpeed,
    getInventoryCircuitSiteOfOrigin,
    getCircuitAccessInformationDetails,
    getCircuitPIPInformationDetails,
    inventoryCircuitModel,
    resetInventoryCircuitForm,
    setInventoryCircuitFormSubmitted,
    updateChangeLocationSite,
    updateChangeLocationSiteP2P,
    getInventoryCircuitPlanDetails,
    getInventoryPlanTypesByVendorByCircuitType,
    updateChangeCircuitPlanComponentDetails,
    getInventoryCircuitPlanComponents,
    getInventoryCircuitGlCodeList,
    getInventoryCircuitCostCenterList,
    setUserLinkedCircuitSearchValue
} from '../../../../constants/model-reducers/external/reports/inventory/circuit.settings';

export const inventoryCircuitInitialState = inventoryCircuitModel;

const defaultState = () => ({
    isInventoryCircuitLoaded: false,
    isInventoryCircuitError: false,
    isInventoryUserDetailLoaded: false,
    isInventoryUserDetailError: false,
    inventoryCircuitItems: DEFAULT_TABLE_RESULT_MODEL,
    inventoryEquipmentItems: DEFAULT_TABLE_RESULT_MODEL,
    inventoryLinkedCircuit: DEFAULT_TABLE_RESULT_MODEL,
    inventoryCircuitColSort: '',
    inventoryCircuitIsSortedAsc: true,
    inventoryCircuitTableFilterList: [],
    inventoryCircuitTableFilterApply: false,
    inventoryCircuitDetail: {
        circuitID: 0,
        circuitCode: "",
        billingAccountID: 0,
        billingAccount: "",
        contract: "",
        vendorID: 0,
        vendor: "",
        currency: "",
        statusID: 0,
        status: "",
        endUserID: null,
        userName: "",
        userHrId: "",
        emailAddress: "",
        forAttentionOf: "",
        planID: 0,
        plan: "",
        monthlyRateCharge: "",
        orderType: "",
        suspensionFromDate: "",
        suspensionToDate: "",
        errorSuspensionPeriod: false,
        hasLinkedCircLogic: false,
        linkedCircuits: [],
        primarySecondary: '',
        dates: {
            suspensionFromDate: "",
            suspensionToDate: "",
            installDate: "",
            disconnectDate: "",
        },
        clientName: "",
        circuitTypeID: 0
    },
    inventoryUserCircuitAllocation: [],
    inventoryUserLinkedCircuit: [],
    inventoryUserHrDetails: {
        hrSapId: "",
        firstName: "",
        lastName: "",
        middle: "",
        emailAdd: "",
        position: "",
        status: "",
        dateleft: "",
        firstLineManagerId: "",
        firstLineManagerEmailAdd: "",
        secondLineManagerId: "",
        secondLineManageremailAdd: "",
        delegateAprover: "",
        locationSiteId: "",
        address1: "",
        address2: "",
        city: "",
        locationState: "",
        country: "",
        locationZip: "",
    },
    circuitLocationAddress: [],
    circuitLocationP2P: [],
    circuitAccessInfoDetails: [],
    circuitPIPInfoDetails: [],
    inventoryAllAccountDetails: [],
    inventoryAllAccountStatuses: [],
    inventoryAllCircuitRankings: [],
    inventoryAllAccountTypes: [],
    inventoryAllCircuitTypes: [],
    inventorySubCircuitTypes: [],
    inventoryAllCircuitEquipment: [],
    inventoryAllCircuitEquipmentModel: [],
    inventoryEquipmentDetailsList: [],
    inventoryAllLocations: [],
    inventoryAllCircuitSimTypes: [],
    inventoryAllEmployees: [],
    inventoryCircuitAccessTypes: [],
    inventoryCircuitAccessBandwidthTypes: [],
    inventoryCircuitEOOITypes: [],
    inventoryCircuitServiceClass: [],
    inventoryCircuitYesOrNo: [],
    inventoryCircuitPortSpeed: [],
    inventoryCircuitCarrierQoSProfile: [],
    inventoryCircuitVPNName: [],
    inventoryCircuitVoiceCarSpeed: [],
    inventoryCircuitSiteOfOrigin: [],
    inventoryCircuitComments: [],
    inventoryCircuitPlans: [],
    inventoryCircuitPlanComponents: DEFAULT_TABLE_RESULT_MODEL,
    inventoryCircuitPlanDetails: DEFAULT_TABLE_RESULT_MODEL,
    circuitCostCenterList: [],
    circuitGlCodeList: [],
});

const initialState = defaultState();

export const inventoryCircuitActions = {
    getInventoryCircuit: (pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryCircuit.inventoryCircuitItems;
        const { inventoryCircuitIsSortedAsc, inventoryCircuitColSort, inventoryCircuitTableFilterList, inventoryCircuitTableFilterApply } = state().inventoryCircuit;

        var userId = sessionStorage.getItem('UserID');

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: inventoryCircuitColSort,
                IsSortAscending: inventoryCircuitIsSortedAsc,
                TableFilterList: inventoryCircuitTableFilterList,
                ApplyFilter: inventoryCircuitTableFilterApply
            };

            var inventoryItems = await httpPost('external/inventory/getAllInventoryItems', data);

            dispatch({
                type: getInventoryCircuit,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        }
        catch (e) {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },
    setInventoryCircuitColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { inventoryCircuitItems } = state().inventoryCircuit;
        var inventoryCircuitItemsUpd = {
            ...inventoryCircuitItems,
            "Headers": {
                ...inventoryCircuitItems.Headers,
                [key]: {

                    ...inventoryCircuitItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInventoryCircuitColSearchStr,
            data: inventoryCircuitItemsUpd,
            isInventoryCircuitError: false,
            isInventoryCircuitLoaded: true
        });
    },
    sortInventoryCircuitItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().inventoryCircuit.inventoryCircuitItems.Pagination;
        const { inventoryCircuitItems, inventoryCircuitTableFilterList, inventoryCircuitTableFilterApply } = state().inventoryCircuit;
        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: inventoryCircuitItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...inventoryCircuitItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: inventoryCircuitTableFilterList,
            ApplyFilter: inventoryCircuitTableFilterApply
        };
        var resInventoryCircuitItems = await httpPost('external/inventory/getAllInventoryItems', data);
        if (resInventoryCircuitItems.ok === false) {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        } else {
            dispatch({
                type: sortInventoryCircuitItems,
                inventoryCircuitItems: Object.keys(resInventoryCircuitItems).length > 0 ? resInventoryCircuitItems : DEFAULT_TABLE_RESULT_MODEL,
                inventoryCircuitColSort: columnClicked,
                inventoryCircuitIsSortedAsc: isSortedAsc,
                isInventoryCircuitLoaded: true
            });
        }
    },

    resizeInventoryCircuitPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setInventoryCircuitPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    getInventoryCircuitGlCodeList: () => async (dispatch, state) => {
        var circuitGlCodeList = await httpGet('external/autosuggest/getInventoryCircuitGLCodes');
        if (circuitGlCodeList != null) {
            dispatch({
                type: getInventoryCircuitGlCodeList,
                circuitGlCodeList: circuitGlCodeList,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitCostCenterList: () => async (dispatch, state) => {
        var circuitCostCenterList = await httpGet('external/autosuggest/getInventoryCircuitCostCodes');
        if (circuitCostCenterList != null) {
            dispatch({
                type: getInventoryCircuitCostCenterList,
                circuitCostCenterList: circuitCostCenterList,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    extractInventoryCircuits: () => async (dispatch, state) => {
        const { Headers } = state().inventoryCircuit.inventoryCircuitItems;
        const { inventoryCircuitIsSortedAsc, inventoryCircuitColSort, inventoryCircuitTableFilterList, inventoryCircuitTableFilterApply } = state().inventoryCircuit;

        const dealName = sessionStorage.getItem('DealName');
        var filename = `ATEM ${dealName} Inventory Extract – ${Moment(new Date()).format('MMDDYYYY').toString()}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: inventoryCircuitColSort,
            IsSortAscending: inventoryCircuitIsSortedAsc,
            FileName: filename,
            TableFilterList: inventoryCircuitTableFilterList,
            ApplyFilter: inventoryCircuitTableFilterApply
        };

        httpDownload('external/inventory/getAllExtractInventoryItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    addInventoryCircuitFilter: (tableFilter) => (dispatch, state) => {
        const { inventoryCircuitTableFilterList } = state().inventoryCircuit;

        var filterList = [...inventoryCircuitTableFilterList, tableFilter];

        dispatch({
            type: setInventoryCircuitFilter,
            filterList: filterList
        })
    },

    removeInventoryCircuitFilter: (removeIndex) => (dispatch, state) => {
        const { inventoryCircuitTableFilterList } = state().inventoryCircuit;

        var filterList = inventoryCircuitTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setInventoryCircuitFilter,
            filterList: filterList
        })
    },

    applyInventoryCircuitFilter: (isApply) => (dispatch, state) => {
        const { inventoryCircuitTableFilterList } = state().inventoryCircuit;

        dispatch({
            type: applyInventoryCircuitFilter,
            applyFilter: isApply,
            filterList: isApply ? inventoryCircuitTableFilterList : []
        });
    },

    saveInventoryCircuitCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryCircuit.inventoryCircuitItems;
        const { inventoryCircuitIsSortedAsc, inventoryCircuitColSort, inventoryCircuitTableFilterList, inventoryCircuitTableFilterApply } = state().inventoryCircuit;

        try {
            var userId = sessionStorage.getItem('UserID');

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.CircuitInventoryManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/inventory/saveCustomizeColumns', customizeFormData);

            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: false,
                isInventoryCircuitLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: inventoryCircuitColSort,
                IsSortAscending: inventoryCircuitIsSortedAsc,
                TableFilterList: inventoryCircuitTableFilterList,
                ApplyFilter: inventoryCircuitTableFilterApply
            };

            var inventoryItems = await httpPost('external/inventory/getAllInventoryItems', data);

            dispatch({
                type: getInventoryCircuit,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        }
        catch (e) {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitDetail: (circuitID, circuitTypeID) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var res = await httpGet('internal/inventoryManager/getOrderSubsciptionDetails/' + dealName + "/" + circuitID + "/" + circuitTypeID);
        var inventoryCircuitDetail = JSON.parse(JSON.stringify(initialState.inventoryCircuitDetail));
        if (res != null) {

            inventoryCircuitDetail.billingAccountID = res.FinanceAccountID;
            inventoryCircuitDetail.billingAccount = res.BillingAccount;
            inventoryCircuitDetail.circuitID = circuitID;
            inventoryCircuitDetail.circuitCode = res.CircuitCode;
            inventoryCircuitDetail.endUserID = res.EndUserID != null ? res.EndUserID.toString() : '';
            inventoryCircuitDetail.userName = res.AssignedUser;
            inventoryCircuitDetail.userHrId = res.UserHrId;
            inventoryCircuitDetail.userEmployeeId = res.UserEmployeeId;
            inventoryCircuitDetail.planID = res.RateID;
            inventoryCircuitDetail.plan = res.PlanName;
            inventoryCircuitDetail.statusID = res.SubsStatus;
            inventoryCircuitDetail.vendorID = res.VendorID;
            inventoryCircuitDetail.vendor = res.Vendor;
            inventoryCircuitDetail.forAttentionOf = res.ForAttention;
            inventoryCircuitDetail.contract = res.Contract;
            inventoryCircuitDetail.currency = res.CurrencyName;
            inventoryCircuitDetail.emailAddress = res.EmailAdd;
            inventoryCircuitDetail.monthlyRateCharge = res.MRC;
            inventoryCircuitDetail.isTaxable = res.IsTaxable ? "Yes" : "No";
            inventoryCircuitDetail.dates.suspensionFromDate = (res.SuspensionFromDate !== null) ? convertToUtcDate(res.SuspensionFromDate, true, "MM/DD/YYYY", 2) : null;
            inventoryCircuitDetail.dates.suspensionToDate = (res.SuspensionToDate !== null) ? convertToUtcDate(res.SuspensionToDate, true, "MM/DD/YYYY", 2) : null;
            inventoryCircuitDetail.hasOrderProgress = res.HasInProgOrder;
            inventoryCircuitDetail.dates.installDate = (res.InstallDate !== null) ? convertToUtcDate(res.InstallDate, true, "MM/DD/YYYY", 1) : null;
            inventoryCircuitDetail.dates.disconnectDate = (res.DisconDate !== null) ? convertToUtcDate(res.DisconDate, true, "MM/DD/YYYY", 1) : null;
            inventoryCircuitDetail.hasLinkedCircLogic = res.HasLinkedCircLogic;
            inventoryCircuitDetail.linkedCircuits = res.LinkedCircuits;
            inventoryCircuitDetail.primarySecondary = res.PrimarySecondary;
            inventoryCircuitDetail.isMPLS = res.IsMPLS;
            inventoryCircuitDetail.newCircNewClientImp = res.NewCircNewClientImp;
            inventoryCircuitDetail.isPTP = res.IsPTP;
            inventoryCircuitDetail.isInternet = res.IsInternet;
            inventoryCircuitDetail.clientName = res.ClientName;
            inventoryCircuitDetail.linkedCircuits = res.LinkedCircuits;
            inventoryCircuitDetail.circuitTypeID = res.CircuitTypeId

            dispatch(actions.reset('inventoryCircuitFormA'));
            dispatch(actions.change('inventoryCircuitFormA.circuitID', circuitID));
            dispatch(actions.change('inventoryCircuitFormA.circuitCode', res.CircuitCode));
            dispatch(actions.change('inventoryCircuitFormA.statusID', res.SubsStatus));
            dispatch(actions.change('inventoryCircuitFormA.clientName', res.ClientName));
            dispatch(actions.change('inventoryCircuitFormA.vendor', res.Vendor));
            dispatch(actions.change('inventoryCircuitFormA.userName', res.AssignedUser));
            dispatch(actions.change('inventoryCircuitFormA.userHrId', res.UserHrId));
            dispatch(actions.change('inventoryCircuitFormA.userEmployeeId', res.UserEmployeeId));
            dispatch(actions.change('inventoryCircuitFormA.endUserID', inventoryCircuitDetail.endUserID));
            dispatch(actions.change('inventoryCircuitFormA.emailAddress', res.EmailAdd));
            dispatch(actions.change('inventoryCircuitFormA.monthlyRateCharge', inventoryCircuitDetail.monthlyRateCharge));
            dispatch(actions.change('inventoryCircuitFormA.currency', res.CurrencyName));
            dispatch(actions.change('inventoryCircuitFormA.billingAccountID', res.FinanceAccountID));
            dispatch(actions.change('inventoryCircuitFormA.primarySecondary', res.PrimarySecondary));
            dispatch(actions.change('inventoryCircuitFormA.financeAccountTypeName', res.FinanceAccountTypeName));
            dispatch(actions.change('inventoryCircuitFormA.lineManager', res.LineManager));
            dispatch(actions.change('inventoryCircuitFormA.circuitTypeID', res.CircuitTypeId));
            dispatch(actions.change('inventoryCircuitFormA.subCircuitTypeID', res.SubCircuitTypeId));
            dispatch(actions.change('inventoryCircuitFormA.location1Id', res.Location1ID));
            dispatch(actions.change('inventoryCircuitFormA.location2Id', res.Location2ID));

            dispatch(actions.change('inventoryCircuitFormA.installDate', inventoryCircuitDetail.dates.installDate));
            dispatch(actions.change('inventoryCircuitFormA.suspensionFromDate', inventoryCircuitDetail.dates.suspensionFromDate));
            dispatch(actions.change('inventoryCircuitFormA.suspensionToDate', inventoryCircuitDetail.dates.suspensionToDate));
            dispatch(actions.change('inventoryCircuitFormA.disconDate', inventoryCircuitDetail.dates.disconnectDate));
            dispatch({
                type: getInventoryCircuitDetail,
                inventoryCircuitDetail: inventoryCircuitDetail,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {

            dispatch(actions.reset('inventoryCircuitFormA'));
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getUserHrDetails: (endUserID) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var userDetail = await httpGet('internal/inventoryManager/getUserHrDetails/' + dealName + "/" + endUserID);
        var inventoryUserHrDetails = JSON.parse(JSON.stringify(initialState.inventoryUserHrDetails));
        if (userDetail != null) {

            inventoryUserHrDetails.employeeId = userDetail.EmployeeId;
            inventoryUserHrDetails.hrSapId = userDetail.HrSapId;
            inventoryUserHrDetails.firstName = userDetail.FirstName;
            inventoryUserHrDetails.lastName = userDetail.LastName;
            inventoryUserHrDetails.middle = userDetail.MiddleInitial;
            inventoryUserHrDetails.emailAdd = userDetail.EmailAddress;
            inventoryUserHrDetails.position = userDetail.Position;
            inventoryUserHrDetails.status = userDetail.Status;
            inventoryUserHrDetails.dateleft = userDetail.DateLeft;
            inventoryUserHrDetails.firstLineManagerId = userDetail.FirstLineManagerID;
            inventoryUserHrDetails.firstLineManagerEmailAdd = userDetail.FirstLineManagerEmailAddress;
            inventoryUserHrDetails.secondLineManagerId = userDetail.SecondLineManagerID;
            inventoryUserHrDetails.secondLineManageremailAdd = userDetail.SecondLineManagerEmailAddress;
            inventoryUserHrDetails.delegateAprover = userDetail.DelegateApprover;
            inventoryUserHrDetails.locationSiteId = userDetail.LocationSiteId;
            inventoryUserHrDetails.address1 = userDetail.Address1;
            inventoryUserHrDetails.address2 = userDetail.Address2;
            inventoryUserHrDetails.city = userDetail.City;
            inventoryUserHrDetails.locationState = userDetail.LocationState;
            inventoryUserHrDetails.country = userDetail.Country;
            inventoryUserHrDetails.locationZip = userDetail.Zip;

            dispatch(actions.reset('inventoryUserDetails'));
            dispatch(actions.change('inventoryUserDetails.employeeId', inventoryUserHrDetails.employeeId));
            dispatch(actions.change('inventoryUserDetails.hrSapId', inventoryUserHrDetails.hrSapId));
            dispatch(actions.change('inventoryUserDetails.firstName', inventoryUserHrDetails.firstName));
            dispatch(actions.change('inventoryUserDetails.lastName', inventoryUserHrDetails.lastName));
            dispatch(actions.change('inventoryUserDetails.middle', inventoryUserHrDetails.middle));
            dispatch(actions.change('inventoryUserDetails.emailAdd', inventoryUserHrDetails.emailAdd));
            dispatch(actions.change('inventoryUserDetails.position', inventoryUserHrDetails.position));
            dispatch(actions.change('inventoryUserDetails.status', inventoryUserHrDetails.status));
            dispatch(actions.change('inventoryUserDetails.dateleft', inventoryUserHrDetails.dateleft));
            dispatch(actions.change('inventoryUserDetails.firstLineManagerId', inventoryUserHrDetails.firstLineManagerId));
            dispatch(actions.change('inventoryUserDetails.firstLineManagerEmailAdd', inventoryUserHrDetails.firstLineManagerEmailAdd));
            dispatch(actions.change('inventoryUserDetails.secondLineManagerId', inventoryUserHrDetails.secondLineManagerId));
            dispatch(actions.change('inventoryUserDetails.secondLineManageremailAdd', inventoryUserHrDetails.secondLineManageremailAdd));
            dispatch(actions.change('inventoryUserDetails.delegateAprover', inventoryUserHrDetails.delegateAprover));
            dispatch(actions.change('inventoryUserDetails.locationSiteId', inventoryUserHrDetails.locationSiteId));
            dispatch(actions.change('inventoryUserDetails.address1', inventoryUserHrDetails.address1));
            dispatch(actions.change('inventoryUserDetails.address1', inventoryUserHrDetails.address2));
            dispatch(actions.change('inventoryUserDetails.city', inventoryUserHrDetails.city));
            dispatch(actions.change('inventoryUserDetails.locationState', inventoryUserHrDetails.locationState));
            dispatch(actions.change('inventoryUserDetails.country', inventoryUserHrDetails.country));
            dispatch(actions.change('inventoryUserDetails.locationZip', inventoryUserHrDetails.locationZip));

            dispatch({
                type: getInventoryUserDetail,
                inventoryUserHrDetails: inventoryUserHrDetails,
                isInventoryUserDetailLoaded: true,
                isInventoryUserDetailError: false
            });
        }
    },

    getUserCircuitAllocation: (employeeId) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var res = await httpGet('internal/inventoryManager/getUserCircuitAllocation/' + dealName + "/" + employeeId);

        if (res != null) {
            dispatch({
                type: getInventoryUserCircuitAllocation,
                inventoryUserCircuitAllocation: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_MODEL,
            });
        }
    },
    getUserLinkedCircuit: (employeeId, searchVal, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination } = state().inventoryCircuit.inventoryLinkedCircuit;
        const dealName = sessionStorage.getItem('DealName');
        var data = {
            SearchValue: searchVal,
            PageFilter: {
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            }
        }

        var res = await httpPost('internal/inventoryManager/getUserLinkedCircuit/' + dealName + "/" + employeeId, data);

        if (res != null) {
            dispatch({
                type: getUserLinkedCircuit,
                inventoryUserLinkedCircuit: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_MODEL,
            });
        }
    },
    getInventoryCircuitLocationAddress: (circuitID) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var res = await httpGet('internal/inventoryManager/getInventoryCircuitLocationDetails/' + dealName + "/" + circuitID);
        var circuitLocationAddress = JSON.parse(JSON.stringify(initialState.circuitLocationAddress));
        if (res !== null) {
            if (res.LocationAddress !== null && res.LocationAddress.State == true) {
                circuitLocationAddress.locationSiteId = res.LocationAddress.LocationId;
                circuitLocationAddress.locationSite = res.LocationAddress.LocationSite;
                circuitLocationAddress.address1 = res.LocationAddress.LocationAddress1;
                circuitLocationAddress.address2 = res.LocationAddress.LocationAddress2;
                circuitLocationAddress.locationCity = res.LocationAddress.LocationCity;
                circuitLocationAddress.locationCountry = res.LocationAddress.CountryName;
                circuitLocationAddress.locationState = res.LocationAddress.LocationState;
                circuitLocationAddress.locationType = res.LocationAddress.LocationType;
                circuitLocationAddress.locationZip = res.LocationAddress.LocationZip;
            }
            circuitLocationAddress.demarcLocation = res.DemarcLocation;
            dispatch({
                type: getInventoryCircuitLocationAddress,
                circuitLocationAddress: circuitLocationAddress,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });

        }
    },

    getInventoryCircuitLocationP2P: (circuitID) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var res = await httpGet('internal/inventoryManager/getInventoryCircuitLocationDetails/' + dealName + "/" + circuitID);
        var circuitLocationP2P = JSON.parse(JSON.stringify(initialState.circuitLocationP2P));
        if (res !== null) {
            if (res.LocationP2P !== null && res.LocationP2P.State == true) {
                circuitLocationP2P.locationSiteId = res.LocationP2P.LocationId;
                circuitLocationP2P.locationSite = res.LocationP2P.LocationSite;
                circuitLocationP2P.address1 = res.LocationP2P.LocationAddress1;
                circuitLocationP2P.address2 = res.LocationP2P.LocationAddress2;
                circuitLocationP2P.locationCity = res.LocationP2P.LocationCity;
                circuitLocationP2P.locationCountry = res.LocationP2P.CountryName;
                circuitLocationP2P.locationState = res.LocationP2P.LocationState;
                circuitLocationP2P.locationType = res.LocationP2P.LocationType;
                circuitLocationP2P.locationZip = res.LocationP2P.LocationZip;
            }
            circuitLocationP2P.demarcLocation = res.DemarcLocationPTP;
            dispatch({
                type: getInventoryCircuitLocationP2P,
                circuitLocationP2P: circuitLocationP2P,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryAllAccountDetails: () => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getAllBillingAccounts');
        if (res != null) {
            dispatch({
                type: getInventoryAllAccountDetails,
                inventoryAllAccountDetails: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryAllAccountTypes: () => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getAllBillingAccountTypes');
        if (res != null) {
            dispatch({
                type: getInventoryAllAccountTypes,
                inventoryAllAccountTypes: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryAllCircuitStatuses: () => async (dispatch, state) => {
        var res = await httpGet('internal/circuit/getCircuitStatuses');

        if (res != null) {
            dispatch({
                type: getInventoryAllCircuitStatuses,
                inventoryAllAccountStatuses: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitEquipment: () => async (dispatch, state) => {
        var res = await httpGet('internal/circuit/getEquipmentTypes');

        if (res != null) {
            dispatch({
                type: getInventoryCircuitEquipment,
                inventoryAllCircuitEquipment: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitEquipmentModel: () => async (dispatch, state) => {
        var res = await httpGet('internal/circuit/getEquipmentModel?contractId=' + 298);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitEquipmentModel,
                inventoryAllCircuitEquipmentModel: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getEquipmentDetailsList: (circuitID) => async (dispatch, state) => {
        const { Headers, Pagination, Data } = state().inventoryCircuit.inventoryEquipmentItems;
        const { Items } = state().inventoryCircuit.inventoryEquipmentItems.Data;
        var data = {
            Headers: {
                ...Headers
            },
            Data: {
                ...Items
            },
        };
        var inventoryItems = await httpGet('internal/circuit/GetCircuitInvEquipmentList?circuitId=' + circuitID, data);
        if (inventoryItems.ok === false) {
            dispatch({
                type: getEquipmentDetailsList,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: getEquipmentDetailsList,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        }

    },
    getInventoryAllCircuitSimTypes: () => async (dispatch, state) => {
        var res = await httpGet('internal/circuit/getCircuitSimTypes');

        if (res != null) {
            dispatch({
                type: getInventoryAllCircuitSimTypes,
                inventoryAllCircuitSimTypes: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitComments: (circuitID) => async (dispatch, state) => {
        var res = await httpGet('internal/inventoryManager/getCircuitComments?circuitID=' + circuitID + '&timeZone=' + getLocalTimeZone());

        if (res != null) {
            dispatch({
                type: getInventoryCircuitComments,
                inventoryCircuitComments: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },
    postInventoryCircuitComments: (circuitID, filename, comment) => async (dispatch, state) => {

        var data = {
            Comment: comment,
            UserID: sessionStorage.getItem('UserID'),
            CircuitID: circuitID,
            FileName: filename,

        };
        var timeZone = getLocalTimeZone()

        var res = await httpPost('internal/inventoryManager/setCircuitComments?timeZone=' + timeZone, data);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitComments,
                inventoryCircuitComments: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    deleteInventoryCircuitComments: (commentId) => async (dispatch, state) => {
        var userId = sessionStorage.getItem("UserID")
        var res = await httpPost('internal/inventoryManager/circuitInventoryDeleteComment/' + commentId + '/' + userId);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitComments,
                circuitDeleteComment: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });

        }
    },

    getInventoryAllCircuitRankings: () => async (dispatch, state) => {
        var res = await httpGet('internal/circuit/GetCircuitRankings');

        if (res != null) {
            dispatch({
                type: getInventoryAllCircuitRankings,
                inventoryAllCircuitRankings: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryAllCircuitTypes: () => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryAllCircuitTypes');

        if (res != null) {
            dispatch({
                type: getInventoryAllCircuitTypes,
                inventoryAllCircuitTypes: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryAllSubCircuitTypes: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryAllSubCircuitTypes/' + id);

        if (res != null) {
            dispatch({
                type: getInventoryAllSubCircuitTypes,
                inventorySubCircuitTypes: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitAccessTypes: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryCircuitAccessTypes/' + 11);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitAccessTypes,
                inventoryCircuitAccessTypes: res,
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitAccessBandwidthTypes: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryCircuitAccessBandwidthTypes/' + 12);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitAccessBandWidthTypes,
                inventoryCircuitAccessBandwidthTypes: res,
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitEoOITypes: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryCircuitEoOITypes/' + 13);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitEOOITypes,
                inventoryCircuitEOOITypes: res,
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitYesOrNoOption: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryCircuitYesOrNoOption');

        if (res != null) {
            dispatch({
                type: getInventoryCircuitYesOrNoOption,
                inventoryCircuitYesOrNo: res,
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitServiceClass: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryCircuitServiceClass/' + 18);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitServiceClass,
                inventoryCircuitServiceClass: res,
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitPortSpeed: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryCircuitPortSpeed/' + 14);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitPortSpeed,
                inventoryCircuitPortSpeed: res,
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitCarrierQoSProfile: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryCircuitCarrierQoSProfile/' + 15);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitCarrierQoSProfile,
                inventoryCircuitCarrierQoSProfile: res,
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitVPNName: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryCircuitVPNName/' + 16);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitVPNName,
                inventoryCircuitVPNName: res,
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitVoiceCarSpeed: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryCircuitVoiceCarSpeed/' + 19);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitVoiceCarSpeed,
                inventoryCircuitVoiceCarSpeed: res,
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryCircuitSiteOfOrigin: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryCircuitSiteOfOrigin/' + 17);

        if (res != null) {
            dispatch({
                type: getInventoryCircuitSiteOfOrigin,
                inventoryCircuitSiteOfOrigin: res,
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getCircuitAccessInformationDetails: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getCircuitAccessInformationItemDetails/' + id);

        if (res != null) {
            dispatch({
                type: getCircuitPIPInformationDetails,
                circuitAccessInfoDetails: res
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getCircuitPIPInformationDetails: (id) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getCircuitPIPInformationDetails/' + id);

        if (res != null) {
            dispatch({
                type: getCircuitPIPInformationDetails,
                circuitPIPInfoDetails: res
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    resetInventoryCircuitForm: () => (dispatch) => {
        dispatch(actions.reset('inventoryCircuitFormA'));
        dispatch({ type: setInventoryCircuitFormSubmitted, data: false });
    },

    getInventoryAllLocations: () => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryAllLocations');
        if (res != null) {
            dispatch({
                type: getInventoryAllLocations,
                inventoryAllLocations: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    getInventoryAllEmployees: () => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryAllEmployees');
        if (res != null) {
            dispatch({
                type: getInventoryAllEmployees,
                inventoryAllEmployees: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }

    },

    resetInventoryCircuitForm: () => (dispatch) => {
        dispatch(actions.reset('inventoryCircuitFormA', 'inventoryCircuitDetail'));
        dispatch({ type: setInventoryCircuitFormSubmitted, data: false });
    },

    updateChangeLocationSite: (model, value) => async (dispatch, state) => {
        var circuitLocationAddress = JSON.parse(JSON.stringify(initialState.circuitLocationAddress));
        dispatch(actions.change(model, value));
        dispatch({
            type: updateChangeLocationSite,
            circuitLocationAddress: model,
            isInventoryCircuitLoaded: true,
            isInventoryCircuitError: false
        });
    },

    updateChangeLocationSiteP2P: (model, value) => async (dispatch, state) => {
        var circuitLocationP2P = JSON.parse(JSON.stringify(initialState.circuitLocationP2P));
        dispatch(actions.change(model, value));
        dispatch({
            type: updateChangeLocationSiteP2P,
            circuitLocationP2P: model,
            isInventoryCircuitLoaded: true,
            isInventoryCircuitError: false
        });
    },
    getInventoryCircuitPlanDetails: (circuitID) => async (dispatch, state) => {
        const { Headers, Pagination, Data } = state().inventoryCircuit.inventoryCircuitPlanDetails;
        const { Items } = state().inventoryCircuit.inventoryCircuitPlanDetails.Data;
        var data = {
            Headers: {
                ...Headers
            },
            Data: {
                ...Items
            },
        };
        var planItems = await httpGet('external/inventory/getInventoryCircuitPlanDetails/' + circuitID);
        if (planItems.ok === false) {
            dispatch({
                type: getInventoryCircuitPlanDetails,
                inventoryCircuitPlanDetails: Object.keys(planItems).length > 0 ? planItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: getInventoryCircuitPlanDetails,
                inventoryCircuitPlanDetails: Object.keys(planItems).length > 0 ? planItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        }
    },

    setUserLinkedCircuitSearchValue: (val, isFilter = false, filterBy = null) => (dispatch) => {
        dispatch({
            type: setUserLinkedCircuitSearchValue
            , value: val
            , filterBy: filterBy
            , isFilter: isFilter
        });
    },

    getInventoryPlanTypesByVendorByCircuitType: (vendorId, circuitTypeId) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoryPlanByVendorByCircuitType/' + vendorId + '/' + circuitTypeId);
        if (res != null && res.length > 0) {
            dispatch({
                type: getInventoryPlanTypesByVendorByCircuitType,
                inventoryCircuitPlans: res,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: setInventoryCircuitError,
                isInventoryCircuitError: true,
                isInventoryCircuitLoaded: false
            });
        }
    },

    updateChangeCircuitPlanComponentDetails: (model, value) => async (dispatch, state) => {
        var inventoryCircuitPlanComponentDetails = JSON.parse(JSON.stringify(initialState.inventoryCircuitPlanComponentDetails));
        dispatch(actions.change(model, value));
        dispatch({
            type: updateChangeCircuitPlanComponentDetails,
            inventoryCircuitPlanComponentDetails: model,
            isInventoryCircuitLoaded: true,
            isInventoryCircuitError: false
        });
    },

    getInventoryCircuitPlanComponents: (planId) => async (dispatch, state) => {
        const { Headers, Pagination, Data } = state().inventoryCircuit.inventoryCircuitPlanComponents;
        const { Items } = state().inventoryCircuit.inventoryCircuitPlanComponents.Data;
        var data = {
            Headers: {
                ...Headers
            },
            Data: {
                ...Items
            },
        };
        var planItems = await httpGet('external/inventory/getInventoryPlanComponentByPlan/' + planId);
        if (planItems.ok === false) {
            dispatch({
                type: getInventoryCircuitPlanComponents,
                inventoryCircuitPlanComponents: Object.keys(planItems).length > 0 ? planItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        } else {
            dispatch({
                type: getInventoryCircuitPlanComponents,
                inventoryCircuitPlanComponents: Object.keys(planItems).length > 0 ? planItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitLoaded: true,
                isInventoryCircuitError: false
            });
        }
    },
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInventoryCircuitGlCodeList:
            return {
                ...state,
                circuitGlCodeList: action.circuitGlCodeList
            }
        case getInventoryCircuitCostCenterList:
            return {
                ...state,
                circuitCostCenterList: action.circuitCostCenterList
            };
        case getInventoryCircuit:
            return {
                ...state,
                inventoryCircuitItems: action.inventoryItems,
                isInventoryCircuitLoaded: action.isInventoryCircuitLoaded,
                isInventoryCircuitError: action.isInventoryCircuitError
            };
        case setInventoryCircuitError:
            return {
                ...state,
                isInventoryCircuitError: action.isInventoryCircuitError,
                isInventoryCircuitLoaded: action.isInventoryCircuitLoaded
            }
        case setInventoryCircuitColSearchStr:
            return {
                ...state,
                inventoryCircuitItems: action.data,
                isInventoryCircuitLoaded: action.isInventoryCircuitLoaded,
                isInventoryCircuitError: action.isInventoryCircuitError
            }
        case sortInventoryCircuitItems:
            return {
                ...state,
                inventoryCircuitItems: action.inventoryCircuitItems,
                inventoryCircuitColSort: action.inventoryCircuitColSort,
                inventoryCircuitIsSortedAsc: action.inventoryCircuitIsSortedAsc,
                isInventoryCircuitLoaded: action.isInventoryCircuitLoaded
            }
        case setInventoryCircuitPageSize:
            return {
                ...state,
                inventoryCircuitItems: {
                    ...state.inventoryCircuitItems,
                    Pagination: {
                        ...state.inventoryCircuitItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setInventoryCircuitFilter:
            return {
                ...state,
                inventoryCircuitTableFilterList: action.filterList
            }
        case applyInventoryCircuitFilter:
            return {
                ...state,
                inventoryCircuitTableFilterApply: action.applyFilter,
                inventoryCircuitTableFilterList: action.filterList
            }
        case getInventoryCircuitDetail:
            return {
                ...state,
                inventoryCircuitDetail: action.inventoryCircuitDetail
            }
        case getInventoryCircuitEquipment:
            return {
                ...state,
                inventoryAllCircuitEquipment: action.inventoryAllCircuitEquipment
            }
        case getInventoryCircuitEquipmentModel:
            return {
                ...state,
                inventoryAllCircuitEquipmentModel: action.inventoryAllCircuitEquipmentModel
            }
        case getEquipmentDetailsList:
            return {
                ...state,
                inventoryEquipmentItems: action.inventoryItems,
                isInventoryCircuitLoaded: action.isInventoryCircuitLoaded,
                isInventoryCircuitError: action.isInventoryCircuitError
            }
        case getInventoryUserDetail:
            return {
                ...state,
                inventoryUserHrDetails: action.inventoryUserHrDetails
            }
        case getInventoryUserCircuitAllocation:
            return {
                ...state,
                inventoryUserCircuitAllocation: action.inventoryUserCircuitAllocation
            }
        case getUserLinkedCircuit:
            return {
                ...state,
                inventoryUserLinkedCircuit: action.inventoryUserLinkedCircuit
            }
        case getInventoryCircuitLocationAddress:
            return {
                ...state,
                circuitLocationAddress: action.circuitLocationAddress
            };
        case getInventoryCircuitLocationP2P:
            return {
                ...state,
                circuitLocationP2P: action.circuitLocationP2P
            };
        case getInventoryAllAccountDetails:
            return {
                ...state,
                inventoryAllAccountDetails: action.inventoryAllAccountDetails
            };
        case getInventoryAllCircuitStatuses:
            return {
                ...state,
                inventoryAllAccountStatuses: action.inventoryAllAccountStatuses
            };
        case getInventoryAllCircuitSimTypes:
            return {
                ...state,
                inventoryAllCircuitSimTypes: action.inventoryAllCircuitSimTypes
            };
        case getInventoryCircuitComments:
            return {
                ...state,
                inventoryCircuitComments: action.inventoryCircuitComments
            };
        case setInventoryCircuitFormSubmitted:
            return {
                ...state,
                formSubmitted: action.data
            };
        case getInventoryAllCircuitRankings:
            return {
                ...state,
                inventoryAllCircuitRankings: action.inventoryAllCircuitRankings
            };
        case getInventoryAllAccountTypes:
            return {
                ...state,
                inventoryAllAccountTypes: action.inventoryAllAccountTypes
            };
        case getInventoryAllCircuitTypes:
            return {
                ...state,
                inventoryAllCircuitTypes: action.inventoryAllCircuitTypes
            }
        case getInventoryAllSubCircuitTypes:
            return {
                ...state,
                inventorySubCircuitTypes: action.inventorySubCircuitTypes
            }
        case getInventoryCircuitAccessTypes:
            return {
                ...state,
                inventoryCircuitAccessTypes: action.inventoryCircuitAccessTypes
            }
        case getInventoryCircuitAccessBandWidthTypes:
            return {
                ...state,
                inventoryCircuitAccessBandwidthTypes: action.inventoryCircuitAccessBandwidthTypes
            }
        case getInventoryCircuitEOOITypes:
            return {
                ...state,
                inventoryCircuitEOOITypes: action.inventoryCircuitEOOITypes
            }
        case getInventoryCircuitServiceClass:
            return {
                ...state,
                inventoryCircuitServiceClass: action.inventoryCircuitServiceClass
            }
        case getInventoryCircuitYesOrNoOption:
            return {
                ...state,
                inventoryCircuitYesOrNo: action.inventoryCircuitYesOrNo
            }
        case getInventoryCircuitPortSpeed:
            return {
                ...state,
                inventoryCircuitPortSpeed: action.inventoryCircuitPortSpeed
            }
        case getInventoryCircuitCarrierQoSProfile:
            return {
                ...state,
                inventoryCircuitCarrierQoSProfile: action.inventoryCircuitCarrierQoSProfile
            }
        case getInventoryCircuitVPNName:
            return {
                ...state,
                inventoryCircuitVPNName: action.inventoryCircuitVPNName
            }
        case getInventoryCircuitVoiceCarSpeed:
            return {
                ...state,
                inventoryCircuitVoiceCarSpeed: action.inventoryCircuitVoiceCarSpeed
            }
        case getInventoryCircuitSiteOfOrigin:
            return {
                ...state,
                inventoryCircuitSiteOfOrigin: action.inventoryCircuitSiteOfOrigin
            }
        case getCircuitAccessInformationDetails:
            return {
                ...state,
                circuitAccessInfoDetails: action.circuitAccessInfoDetails
            }
        case getCircuitPIPInformationDetails:
            return {
                ...state,
                circuitPIPInfoDetails: action.circuitPIPInfoDetails
            }
        case getInventoryAllLocations:
            return {
                ...state,
                inventoryAllLocations: action.inventoryAllLocations
            }
        case updateChangeLocationSite:
            return {
                ...state,
                circuitLocationAddress: action.circuitLocationAddress
            }
        case updateChangeLocationSiteP2P:
            return {
                ...state,
                circuitLocationP2P: action.circuitLocationP2P
            }
        case getInventoryAllEmployees:
            return {
                ...state,
                inventoryAllEmployees: action.inventoryAllEmployees
            }
        case getInventoryCircuitPlanDetails:
            return {
                ...state,
                inventoryCircuitPlanDetails: action.inventoryCircuitPlanDetails
            }
        case getInventoryPlanTypesByVendorByCircuitType:
            return {
                ...state,
                inventoryCircuitPlans: action.inventoryCircuitPlans
            }
        case updateChangeCircuitPlanComponentDetails:
            return {
                ...state,
                inventoryCircuitPlanComponentDetails: action.inventoryCircuitPlanComponentDetails
            }
        case getInventoryCircuitPlanComponents:
            return {
                ...state,
                inventoryCircuitPlanComponents: action.inventoryCircuitPlanComponents
            }
        case setUserLinkedCircuitSearchValue:
            return {
                ...state
                , searchValue: action.value
                , isFilter: action.isFilter
                , filterBy: action.filterBy
            };
        default:
            return state;
    }
};
